import { FETCH_NATOPS } from '../actions/types';

export default function (state = [], action) {
    switch (action.type) {
        case FETCH_NATOPS:
            return action.payload;
        default:
            return state;
    }
}